module.exports = __webpack_public_path__ + "media/images/menu/comments-3359a05359312e9475b43fe656484782.svg";